import React from "react";
import { NextButton } from "../../shared/components/Buttons";
import { useTranslation } from "react-i18next";

const SubmitButton = ({ disabled, onClick, classname }) => {
    const { t } = useTranslation();
    return (
        <NextButton
            type="submit"
            disabled={disabled}
            classname={classname}
            onClick={onClick}
        >
            {t("Envoyer ma demande")}
        </NextButton>
    );
};
export default SubmitButton;
